// rolodex v2 permission types

export type RolodexPermissionsUser = {
  id: string
  active: boolean
  name: string | undefined
  email: string | undefined
}

export type RolodexRole = {
  id: string
  name: string
  created_at: string | null
  updated_at: string | null
  created_by: string | null
  updated_by: string | null
  // todo fixme
  organization_id: string | null
  organizationId: string | null
}

export type RolodexUserMetadata = {
  active: boolean
  name: string
  email: string
  id: string
  roles: RoleWithPermission[]
  userPermissions: Permission[]
}

// combination of data coming from auth0 and rolodex
export type ConsolidatedUser = {
  active?: boolean
  email: string
  id?: string
  auth0Id?: string
  rolodexId?: string
  inviteStatus?: string
  name?: string
  permissions?: string[]
  roles?: RoleWithPermission[]
}

export type Permission = {
  id: string
  name: string
  permission: object
}

export type RolePermission = Permission & { roleId: string }

export type RoleMetadata = {
  id: string
  name: string
  createdBy: string
  updatedBy: string
  createdAt: string
  updatedAt: string
}

export type RoleWithPermission = {
  id: string
  name: string
  permissions: { [key: string]: Permission }
  organizationId: string | null
  numUsers: number
}

export type RolodexResource = {
  type: string | null
  tags: Record<string, string> | null
  id: string | null
}

export type RolodexPermission = {
  action: RoleAction[]
  resource: RolodexResource[]
}

export enum RoleScopeAndType {
  ORG_ADMIN = 'orgAdmin',
  ORG_MEMBER = 'orgMember',
  SITE_ADMIN = 'siteAdmin',
  SITE_MEMBER = 'siteMember',
}

export enum RoleScope {
  ORG = 'organization',
  SITE = 'site',
}

export enum RoleType {
  ADMIN = 'admin',
  MEMBER = 'member',
}

export enum RoleAction {
  CREATE = 'create',
  DELETE = 'delete',
  EDIT = 'edit',
  READ = 'read',
}

export enum OrgUsersTableRoleType {
  ADMIN = 'admin',
  MEMBER = 'member',
  SITE = 'site',
}
